export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    if (error.message.indexOf('VIREMENT_BANK_IBAN_EMPTY') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.virementBankIbanEmpty',
      });
    }
    if (error.message.indexOf('VIREMENT_BIC_EMPTY') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.virementBankBicEmpty',
      });
    }
    if (error.message.indexOf('VIREMENT_BANK_SEPA_ID_EMPTY') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.virementBankSepaIdEmpty',
      });
    }
    if (error.message.indexOf('VIREMENT_BANK_INACTIVE') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.virementBankInactive',
      });
    }
    if (error.message.indexOf('VIREMENT_BANK_HOLDER_EMPTY') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.virementBankHolderEmpty',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
    if (error.message.indexOf('VIREMENT_BANK_NAME_EMPTY') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.virementBankNameEmpty',
      });
    }
    if (error.message.indexOf('VIREMENT_LINE_AMOUNT_LESS_EQUAL_ZERO') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.virementLineAmountLessEqualZero',
      });
    }
    if (error.message.indexOf('VIREMENT_LINE_COUNT_EMPTY') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.virementLineCountEmpty',
      });
    }
    if (error.message.indexOf('VIREMENT_LINE_PERSON_EMPTY') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.virementLinePersonEmpty',
      });
    }
    if (error.message.indexOf('VIREMENT_LINE_PERSON_HOLDER_EMPTY') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.virementLinePersonHolderEmpty',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
    if (error.message.indexOf('BIC_LENGTH_8_OR_11') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.bic.length',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
    if (error.message.indexOf('BIC_NOT_EMPTY_OR_NULL') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.bic.bicNotEmptyOrNull',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
    if (error.message.indexOf('BIC_BRANCH_CODE_ONLY_LETTERS_OR_DIGITS') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.bic.branchCodeOnlyLettersOrDigit',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
    if (error.message.indexOf('COUNTRY_CODE_UNSUPPORTED') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      if (error.message.indexOf('Bic') !== -1) {
        messages.push({
          message: 'detailLotPaiement.messages.error.bic.countryCodeUnsupported',
          parametres: {
            bailleur: bailleur,
          },
        });
      } else {
        messages.push({
          message: 'detailLotPaiement.messages.error.iban.countryCodeUnsupported',
          parametres: {
            bailleur: bailleur,
          },
        });
      }
    }
    if (error.message.indexOf('BIC_GENERIC_ERROR') === 0) {
      const params = error.message.split('|')[0].split('@');
      messages.push({
        message: 'detailLotPaiement.messages.error.bic.genericError',
        parametres: {
          code: params[0],
          bailleur: params[1],
        },
      });
    }
    if (error.message.indexOf('IBAN_BAD_LENGHT') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.iban.length',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
    if (error.message.indexOf('COUNTRY_CODE_UPPER_CASE_LETTERS') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.iban.countryCodeUpperCaseLetters',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
    if (error.message.indexOf('IBAN_GENERIC_ERROR') === 0) {
      const params = error.message.split('|')[0].split('@');
      messages.push({
        message: 'detailLotPaiement.messages.error.iban.genericError',
        parametres: {
          code: params[0],
          bailleur: params[1],
        },
      });
    }
    if (error.message.indexOf('IBAN_INVALID_CHECK_DIGIT_VALUE') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.iban.invalidCheckDigitValue',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
    if (error.message.indexOf('IBAN_NOT_EMPTY_OR_NULL') === 0) {
      const bailleur = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'detailLotPaiement.messages.error.iban.ibanNotEmptyOrNull',
        parametres: {
          bailleur: bailleur,
        },
      });
    }
  });
}
